import { render } from "./AdminPRTimeline.vue?vue&type=template&id=d20308a0"
import script from "./AdminPRTimeline.vue?vue&type=script&lang=js"
export * from "./AdminPRTimeline.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__